<template>
  <div>
    <el-page-header class="detail-head" @back="goBack" content="栏目详情"> </el-page-header>
    <el-divider class="detail-divider"></el-divider>

    <el-tabs model-value="first">
      <el-tab-pane label="基础信息" name="first">
        <div class="detail-containe-product">
          <el-scrollbar>
            <el-form class="detail-form" ref="mainForm" :model="entity" :rules="rules" label-width="100px">
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="名称" class="detail-form-item" prop="name">
                      <el-input size="medium" v-model="entity.name" @blur="pinyin"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="编码" class="detail-form-item" prop="code">
                      <el-input size="medium" v-model="entity.code"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="状态" class="detail-form-item">
                      <el-select class="detail-form-item-select" size="medium" v-model="entity.state">
                        <el-option v-for="item in states" :key="item.itemKey" :label="item.itemValue" :value="item.itemKey">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="上级栏目" class="detail-form-item">
                      <el-select class="detail-form-item-select" size="medium" v-model="entity.parentId" clearable>
                        <el-option v-for="item in parents" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>

              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="排序号" class="detail-form-item">
                      <el-input-number size="medium" v-model="entity.sortNo"></el-input-number>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="文章排序类型" class="detail-form-item">
                      <el-radio-group v-model="entity.sortType">
                        <el-radio label="desc">降序排列</el-radio>
                        <el-radio label="asc">升序排列</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="文章分页数量" class="detail-form-item">
                      <el-input-number size="medium" v-model="entity.pageSize"></el-input-number>
                    </el-form-item>
                  </div>
                </el-col>                
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="缩略图">
                    <el-upload class="avatar-uploader" action="customize" :auto-upload="true" :show-file-list="false" :http-request="uploadFile">
                      <img v-if="entity.img" :src="entity.img" class="avatar" />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="栏目标签" class="detail-form-item">
                      <el-select-v2 size="medium" v-model="tagValues" :options="tagOptions" multiple style="width:100%" />
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="grid-content">
                    <el-form-item label="自定义扩展" class="detail-form-item">
                      <el-select class="detail-form-item-select" size="medium" v-model="entity.customId" clearable>
                        <el-option v-for="item in customs" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="grid-content">
                    <el-form-item label="导航栏" class="detail-form-item">
                      <el-radio-group v-model="entity.nav">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="grid-content">
                    <el-form-item label="启用静态化" class="detail-form-item">
                      <el-radio-group v-model="entity.staticize">
                        <el-radio :label="true">启用</el-radio>
                        <el-radio :label="false">禁用</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="grid-content">
                    <el-form-item label="栏目链接" class="detail-form-item">
                      <el-input size="medium" v-model="entity.url"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content">
                    <el-form-item label="手机栏目链接" class="detail-form-item">
                      <el-input size="medium" v-model="entity.mobileUrl"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="创建人" class="detail-form-item">
                      <el-input size="medium" v-model="entity.creator" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="创建时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.createTime" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="修改人" class="detail-form-item">
                      <el-input size="medium" v-model="entity.modifier" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="修改时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.modifyTime" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <div class="grid-content">
                    <el-form-item label="备注" class="detail-form-item">
                      <el-input type="textarea" v-model="entity.remark"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </el-scrollbar>
        </div>
      </el-tab-pane>
      <el-tab-pane label="模板信息" name="second">
        <div class="detail-containe-product">
          <el-form class="detail-form" ref="secondForm" :model="entity" :rules="rules" label-width="100px">
            <el-row :gutter="20">
              <el-col :span="6">
                <div class="grid-content">
                  <el-form-item label="栏目类型" class="detail-form-item">
                    <el-select class="detail-form-item-select" size="medium" v-model="entity.type">
                      <el-option v-for="item in types" :key="item.itemKey" :label="item.itemValue" :value="item.itemKey">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content">
                  <el-form-item label="文章列表模板" class="detail-form-item">
                    <el-select class="detail-form-item-select" size="medium" v-model="entity.listTemplateId" clearable>
                      <el-option v-for="item in listTemplates" :key="item.id" :label="item.name" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content">
                  <el-form-item label="文章详情模板" class="detail-form-item">
                    <el-select class="detail-form-item-select" size="medium" v-model="entity.detailTemplateId" clearable>
                      <el-option v-for="item in detailTemplates" :key="item.id" :label="item.name" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content">
                  <el-form-item label="栏目封面模板" class="detail-form-item">
                    <el-select class="detail-form-item-select" size="medium" v-model="entity.indexTemplateId" clearable>
                      <el-option v-for="item in itemTemplates" :key="item.id" :label="item.name" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <div class="grid-content">
                  <el-form-item label="栏目导航类型" class="detail-form-item">
                    <el-select class="detail-form-item-select" size="medium" v-model="entity.navType">
                      <el-option v-for="item in navTypes" :key="item.itemKey" :label="item.itemValue" :value="item.itemKey">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content">
                  <el-form-item label="导航子文章" class="detail-form-item">
                    <el-select class="detail-form-item-select" size="medium" v-model="entity.subContentId" clearable>
                      <el-option v-for="item in childContents" :key="item.id" :label="item.title" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content">
                  <el-form-item label="导航子栏目" class="detail-form-item">
                    <el-select class="detail-form-item-select" size="medium" v-model="entity.subCategoryId" clearable>
                      <el-option v-for="item in childCategorys" :key="item.id" :label="item.name" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-divider class="detail-divider"></el-divider>
    <div class="detail-form-item-btns">
      <el-button v-if="edit" size="medium" class="detail-form-item-btn" type="primary" @click="save">保存</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="goBack">返回列表</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="reset">刷新</el-button>
    </div>
  </div>
</template>

<script lang="ts">
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import {
  Category,
  Content,
  Tag,
  Template,
} from "@/script/apps/cms/entity/CmsEntity";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { DictUtil } from "@/script/core/Dict";
import { CategoryService } from "@/script/apps/cms/service/CategoryService";
import { DictService } from "@/script/apps/system/service/DictService";
import { ElMessage } from "element-plus";
import { AppConfig } from "@/script/core/base/AppConfig";
import { Custom, Dict } from "@/script/apps/system/entity/SystemEntity";
import { TagService } from "@/script/apps/cms/service/TagService";
import { CustomService } from "@/script/apps/system/service/CustomService";
import { ContentService } from "@/script/apps/cms/service/ContentService";
import { TemplateService } from "@/script/apps/cms/service/TemplateService";

@Options({})
export default class CategoryDetail extends BaseDetail {
  private parents: Category[] = [];
  private childCategorys: Category[] = [];
  private childContents: Content[] = [];
  private navTypes: Dict[] = [];
  private listTemplates: Template[] = [];
  private itemTemplates: Template[] = [];
  private detailTemplates: Template[] = [];
  private tagValues: number[] = [];
  private tagOptions: any[] = [];
  private customs: Custom[] = [];

  private service = new CategoryService();

  public initData(): ServiceContext {
    const data = ServiceFactory.build(
      "biz_cms_category",
      "/cms/category",
      "/cms/category",
      this.service
    );
    data.typesName = "category-type";
    return data;
  }

  private rules = {
    code: [{ required: true, message: "请输入编码", trigger: "blur" }],
    name: [{ required: true, message: "请输入名称", trigger: "blur" }],
  };

  protected initOptions() {
    super.initOptions();
    this.service.loadParentCategorys(this.id, (data: any) => {
      this.parents = data;
    });
    this.service.loadChildCategorys(this.id).then((result: any) => {
      this.childCategorys = result.data.list;
    });

    const contentService = new ContentService();
    contentService.loadChildContents(this.id).then((result: any) => {
      this.childContents = result.data.list;
    });
    const tagService = new TagService();
    tagService.loadTagsByType("category", (data: any) => {
      const tags: Tag[] = data;
      this.tagOptions = [];
      tags.forEach((item) => {
        this.tagOptions.push({
          value: item.id,
          label: item.name,
        });
      });
    });
    const dictService = new DictService();
    dictService.loadChildItems("category-nav-type", (data: any) => {
      this.navTypes = data;
    });

    const templateService = new TemplateService();
    templateService.loadListByType("list").then((result: any) => {
      this.listTemplates = result.data.list;
    });
    templateService.loadListByType("index").then((result: any) => {
      this.itemTemplates = result.data.list;
    });
    templateService.loadListByType("content").then((result: any) => {
      this.detailTemplates = result.data.list;
    });

    const customService = new CustomService();
    customService.loadAllList("/api/sys/custom/list", (data: any) => {
      this.customs = data.list;
    });
  }

  public newEntity() {
    const entity: Category = {};
    const parentId = this.$route.query.parentId;
    if (parentId) {
      entity.parentId = Number(parentId);
    }
    entity.sortNo = 1;
    entity.type = "template";
    entity.mobileEnable = false;
    entity.navType = "list";
    entity.sortType = "desc";
    entity.pageSize = 20;
    // entity.listTemplateId = 100;
    // entity.detailTemplateId = 200;
    entity.listTemplate = "/cms/default/list.ftl";
    entity.detailTemplate = "/cms/default/content.ftl";
    entity.staticize = false;
    entity.nav = false;
    return entity;
  }

  uploadFile(param: any) {
    const path = "cms";
    const formData = new FormData();
    formData.append("path", path);
    formData.append("files", param.file, param.file.name);
    this.service.uploadFile(formData).then(
      (result) => {        
          const uploadUrl =
          AppConfig.Config.ServerUrl + `file/${path}/${result.data}`;
        this.entity.img = uploadUrl;
      },
      (error: Error) => {
        ElMessage.error("上传图片失败！原因：" + error);
      }
    );
  }

  afterLoad(data: any) {
    if (this.entity.tagIds) {
      const tagIds: [] = this.entity.tagIds.split(",");
      this.tagValues = [];
      tagIds.forEach((item) => {
        this.tagValues.push(Number(item));
      });
    }
  }

  beforeSave() {
    const tagIds = this.tagValues.join(",");
    this.entity.tagIds = tagIds;
    const category = this.entity as Category;

    if (category.listTemplateId) {
      this.listTemplates.forEach((item) => {
        if (item.id === category.listTemplateId) {
          category.listTemplate = item.path;
        }
      });
    } else {
      category.listTemplate = "";
    }
    if (category.indexTemplateId) {
      this.itemTemplates.forEach((item) => {
        if (item.id === category.indexTemplateId) {
          category.indexTemplate = item.path;
        }
      });
    } else {
      category.indexTemplate = "";
    }
    if (category.detailTemplateId) {
      this.detailTemplates.forEach((item) => {
        if (item.id === category.detailTemplateId) {
          category.detailTemplate = item.path;
        }
      });
    } else {
      category.detailTemplate = "";
    }
    return true;
  }

  private pinyin() {
    const category = this.entity as Category;
    this.service.pinyin(category.name!).then((result: any) => {
      category.code = result.data;
    });
  }
}
</script>

<style lang="scss">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
